import { SymbolWin } from '@1x2network/is_engine_communication'
import { WinLines } from '@1x2network/pixi_win_lines'
import { PositionTuple, TradReelSet } from '@1x2network/reel_set'
import { removeDuplicatePositionTuples } from '../../utils/positionTuple'

/**
 * Initialise any game specific behaviors of the win lines
 * @author Adam Drake - <adam.drake@1x2network.com>
 * @version 1.0.0
 */

/**
 * add listeners to handle promotion and demotion of symbols displaying winlines over the top of none winning symbols
 * @param reelSet this games reel set
 * @param winLines this games win lines
 * @param lines matrix of line positions
 */
export function initWinLines(reelSet: TradReelSet, winLines: WinLines<SymbolWin>, lines: number[][]): void {
    const linePositions = lines.map((line) => {
        return line.map((row, reel) => reelSet.getSymbolPosition(reel, row))
    })

    winLines.setLines(linePositions)

    winLines.onShowLine.connect((_w, _n, symbolWins) => {
        const winningPositions = removeDuplicatePositionTuples(
            symbolWins.map((symbolWin) => symbolWin.positions).flat(1),
        )
            // Sort by row and then by reel
            .sort((a, b) => {
                if (a[1] === b[1]) {
                    return a[0] - b[0]
                }
                return a[1] - b[1]
            })

        const nonWinningPositions: PositionTuple[] = []
        for (let i = 0; i < 5; i++) {
            for (let j = 0; j < 3; j++) {
                const position = [i, j] as PositionTuple
                if (!winningPositions.some((pos) => pos[0] === position[0] && pos[1] === position[1])) {
                    nonWinningPositions.push(position)
                }
            }
        }

        reelSet.demoteSymbolsByPosition(nonWinningPositions)
        reelSet.promoteSymbolsByPosition(winningPositions)
    })
}
